import { writable } from 'svelte/store';
import type { Writable } from 'svelte/store';
export const showGlobalLoader: Writable<boolean> = writable<boolean>(false);
export const globalLoaderMsg: Writable<string> = writable<string>('');
